// @ts-strict-ignore
import React, {
  useCallback,
  useEffect,
} from 'react';
import {
  useParams,
  NavLink,
  useNavigate,
} from 'react-router-dom';
import {
  Box, Text,
} from '@usealloy/component-library';

import { ajaxFetch } from '~/helpers/api';
import log from '~/helpers/logging';
import { routes } from '~/helpers/routes';
import { StyledLink } from '../AuthContainerView/styles';
import { ValidateEmailMode } from '~/dashboard/constants';

const VerifyEmailView = ({
  mode = ValidateEmailMode.VALIDATEEMAIL,
}: { mode: ValidateEmailMode }) => {
  const navigate = useNavigate();
  const { tokenUid, tokenCid, token } = useParams();

  const verifyToken = useCallback(async () => {
    const endpointUrl = (mode === ValidateEmailMode.VALIDATEEMAIL)
      ? routes.authentication.verifyEmail(`${tokenUid}/${token}`)
      : routes.authentication.verifyCustomerEmail(`${tokenUid}/${tokenCid}/${token}`);
    try {
      const response = await ajaxFetch(endpointUrl, { enhancedErrorResponse: true });

      if (response?.result === 'success') {
        navigate(routes.v3.dashboard.authentication.login, {
          replace: true,
          state: {
            message: {
              text: 'The agent email was verified and the account has been activated. Please sign in.',
              type: 'success',
            },
          },
        });
      }
    } catch (error) {
      navigate(routes.v3.dashboard.authentication.login, {
        replace: true,
        state: {
          message: {
            text: error.message || 'The account/email could not be verified. Please try again or contact support.',
            type: 'danger',
          },
        },
      });
      log('error', `GET ${endpointUrl} exception`, {}, error);
    }
  }, [navigate, token, tokenUid]);

  useEffect(() => {
    verifyToken();
  }, [verifyToken]);

  return (
    <Box direction="column" gap={4} alignItems="stretch" style={{ width: '440px' }}>
      <Text as="h1" size={7} style={{ textAlign: 'center' }}>Verifying email</Text>

      <NavLink to={routes.v3.dashboard.authentication.login}>
        <StyledLink forwardedAs="span">
          Return to sign in
        </StyledLink>
      </NavLink>
    </Box>
  );
};

export default VerifyEmailView;
